module.exports = {
  AUTHENTICATION: 'authentication',
  AUTHORIZATION: 'authorization',
  CANCEL: 'cancel',
  CAPTURE: 'capture',
  CHARGEBACK: 'chargeback',
  REFUND: 'refund',
  RISK_ASSESSMENT: 'risk_assessment',
};
